
import React, { useEffect, useState } from 'react';


import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

import { DialogButton, DialogClose } from '../../types';
import { useIcon } from '../../hooks';





export interface FabrixConfirmDialogProps {
    id?: string;
    text: string;
    open: boolean;
    onClose?: DialogClose;
    buttons: DialogButton[],
    title: string;
    item?: any;

}

/**
 * Renders a reusable confirmation dialog with configurable buttons and callbacks.
 * @param props Dialog configuration including content, visibility state, and actions.
 * @returns PrimeReact dialog element prompting the user for confirmation.
 */
export function FabrixConfirmDialog(props: FabrixConfirmDialogProps) {

    const icon = useIcon();
    const [_dialogOpen, setDialogOpen] = useState<boolean>(false);
    const dialogId = props.id ?? 'fabrix-confirm-dialog';


    useEffect(() => {
        setDialogOpen(props.open)
    }, [props.open])



    /**
     * Fires the close callback with the selected button identifier.
     * @param id Identifier of the button that triggered the close event.
     */
    const handleClose = (id: any) => {

        if (props.onClose) {
            props.onClose(id, props.item)
        }
    }


    /**
     * Creates footer buttons based on supplied dialog button definitions.
     * @returns Array of PrimeReact Button elements.
     */
    const renderFooter = () => {
        return props.buttons.map((value, index) => {
            return (
                <Button id={`${dialogId}-button-${value.id}`} data-testid={`${dialogId}-button-${value.id}`}
                    disabled={value.disabled} key={`btn-dialog-${index}`} label={value.text}
                    icon={icon(value.icon ?? '')}
                    onClick={() => handleClose(value.id)} className={`p-button-outlined fbx-button-outlined confirm-dialog-button ${value.className}`} />

            )
        })
    }






    return (
        <Dialog id={dialogId} data-testid={dialogId} header={props.title} visible={_dialogOpen} className="adv-user-dialog" footer={renderFooter()} onHide={() => handleClose(0)}>

            <div id={`${dialogId}-content`} data-testid={`${dialogId}-content`}>

                <span dangerouslySetInnerHTML={{ __html: props.text }}></span>

            </div>

        </Dialog>
    )
}
